import React from 'react';
import { Image } from 'expo-image';
import { Text, Flex } from 'native-base';
import { BlurView } from 'expo-blur';
import { AppData, formatPoints } from '@breakroom-nx/helpers';
import gem from '../../../../assets/src/images/gem.webp';

export interface PointsTagProps {
  amount: number;
  payment: boolean;
  fontSize?: number;
  imageSize?: number;
  showBackground?: boolean;
  px?: number;
}

export function PointsTag({
  amount,
  payment,
  fontSize = 10,
  imageSize = 10,
  showBackground = false,
  px = 2.5,
}: PointsTagProps) {
  return (
    <BlurView
      tint="dark"
      intensity={45}
      style={{
        borderRadius: 50,
        overflow: 'hidden',
      }}
    >
      <Flex
        direction={'row'}
        px={px}
        py={px * 0.5}
        rounded={'full'}
        bg={showBackground ? 'surface.300' : null}
        maxWidth={'100%'}
        alignItems={'center'}
        style={{
          shadowColor: 'black',
          shadowOpacity: 0.25,
          shadowOffset: { width: 0, height: 1 },
          shadowRadius: 4,
        }}
      >
        <Image
          source={{ uri: gem }}
          cachePolicy={'memory-disk'}
          accessibilityLabel={`${AppData.CURRENCY_NAME} image`}
          style={{
            width: '15px',
            aspectRatio: 1,
          }}
        />
        <Text
          ml={1}
          flexShrink={1}
          color={'yellow.200'}
          fontSize={fontSize}
          fontWeight={600}
          isTruncated
          maxWidth={'full'}
        >
          {(payment ? '+' : '') + formatPoints(amount)}
        </Text>
      </Flex>
    </BlurView>
  );
}

export default React.memo(PointsTag);
